import React, { useContext, useEffect, useState } from "react";
import { Button } from "antd";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { faSignOutAlt, } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";

const ClientesDashboard = (props) => {

  const styles = `
  .Maquinas-page {
  background-color: black;
  color: white; 
  margin: 0; 
  padding: 0; 
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  background-color: black;
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100vw;
  overflow: auto;   
  }
  .Container_atualizar {
    display: flex;
    align-items: center; 
    justify-content: space-between; 
    padding: 5px 20px; 
    gap: 15px; 
  }  
  .Cliente_titulo {
    margin-top: 15px; 
    color: #c8dd06; 
    margin-left: 50px;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .Botao-Atualizar {
    height: auto;
    font-size: 20px;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    background-color:rgb(4, 8, 247);
    color: white;
    margin: 0 20px;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #ffffff;
    padding: 20px; 
  }
  .Botao-Atualizar:hover {
    background-color:rgb(103, 105, 255);
  }
  .Botao-Adicionar {
    margin-top: 30px; 
    font-size: 20px;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    margin: 0 20px;
    background-color:rgb(174, 3, 197);
    color: white;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #ffffff;
    padding: 20px; 
  }
  .Botao-Adicionar:hover {
    background-color:rgb(229, 81, 248);
  }   
  .Botao-Sair {
    font-size: 20px;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    background-color:rgb(250, 2, 2);
    color: white;
    margin: 0 50px;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #ffffff;
    padding: 20px; 
  }
  .Botao-Sair:hover {
    background-color:rgb(69, 56, 252);
  } 
  .Clientes_principal {
    display: flex;
    flex-wrap: wrap;
    gap: 14px; 
    padding: 0 20px;
    margin: 15px 30px; 
    justify-content: center;
  }

  .Cliente_coluna {
    flex: 1 1 calc(25% - 20px);
    max-width: calc(25% - 20px);
    display: flex;
    flex-direction: column;
  }
  .Cliente_click {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 14px;
    cursor: pointer;
    transition: box-shadow 0.3s ease, max-height 0.3s ease;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .Cliente_click.expanded {
    overflow: auto;
  }
  .Cliente_click:hover {
    box-shadow: 0 0 20px rgba(0, 146, 8, 0.5);
  }
  .Cliente_nome {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 10px;
  }
  .Cliente_email {
    font-size: 16px;
    color: #ffffff;
    margin-bottom: 10px;
  }
  .Cliente_footer {
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 10px;
  }
  .Cliente_maquina {
    font-size: 16px;
    font-style: italic;
    color: #ffffff;
    margin-bottom: 10px;
  }

  @media only screen and (max-width: 1020px) and (orientation: landscape) {
   .Cliente_coluna {
    flex: 1 1 calc(50% - 10px); 
    max-width: calc(50% - 10px);
   }
   .Cliente_titulo {
    margin-left: 0; 
    text-align: center; 
    width: 100%;
   }
   .Container_atualizar {
    flex-direction: row; 
    align-items: center; 
    justify-content: center; 
    gap: 15px; 
    padding: 0 20px; 
   }
   .Botao-Adicionar, .Botao-Sair {
    width: auto; 
    padding: 20px; 
    box-sizing: border-box; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
   }
  }

  @media only screen and (max-width: 760px) and (orientation: portrait) {
    .Cliente_coluna {
    flex: 1 1 100%; 
    max-width: 100%; 
    }
    .Container_atualizar {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 0 20px;
    }
    .Cliente_titulo {
    margin-left: 0;
    text-align: center;
    width: 100%;
    }
    .Botao-Adicionar, .Botao-Sair {
    width: 300px; 
    margin: 0 auto;
    padding: 30px 30px; 
    align-items: center;
    justify-content: center;
    box-sizing: border-box; 
    text-transform: uppercase; 
    }
  }
}

  `;
  
    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const [expandedClientId, setExpandedClientId] = useState(null);

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  let navigate = useNavigate();

  const token = authInfo?.dataUser?.token;

  const [totalClientes, setTotalClientes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line
  }, []);

  const dataData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_SERVIDOR}/clientes`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
  
          const clientesData = Array.isArray(res.data) ? res.data : [];
  
          // console.log("Clientes recebidos:", clientesData);
  
          setTotalClientes(clientesData);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "Sua sessão expirou, faça login novamente. 05",
          });
          setDataUser(null);
        }
      });
  };
  

  const handleClienteClick = ({
    id,
    nome,
    email,
    ativo,
    dataInclusao,
    dataVencimento,
    ultimoAcesso,
    mercadoPagoToken,
  }) => {
    const cliente = {
      id,
      nome,
      email,
      ativo,
      dataInclusao,
      dataVencimento,
      ultimoAcesso,
      mercadoPagoToken,
    };
    navigate(`/cliente-maquinas/${id}`, {
      state: cliente,
    });
  };

  const handleLogout = () => {
    setDataUser(null);
    navigate("/admin-sign-in");
  };

  return (
    <div className="Maquinas-page">
      {isLoading && <LoadingAction />}

      <div className="Container_atualizar">
        <div className="Cliente_titulo">
          {/* Correção importante: verificar se totalClientes é array antes de usar reduce */}
          {totalClientes.length} CLIENTES E{" "}
          {Array.isArray(totalClientes) 
            ? totalClientes.reduce(
                (acc, cliente) => acc + (cliente.Maquina?.length || 0),
                0
              )
            : 0}{" "}
          MÁQUINAS
        </div>

        <Link to={"/novo-cliente"}>
          <Button className="Botao-Adicionar">
            <AiOutlinePlusCircle />
            <span>Criar novo cliente</span>
          </Button>
        </Link>
        <Button className="Botao-Sair" onClick={handleLogout}>
          <FontAwesomeIcon icon={faSignOutAlt} />
          <span>Sair</span>
        </Button>
      </div>

      <div className="Clientes_principal">
        {totalClientes.map((post, index) => {
          if (!post || !post.nome) return null;

          const datadeVencimento = post.dataVencimento
            ? new Date(post.dataVencimento)
            : null;
          const hoje = new Date();
          const isVencida = datadeVencimento ? hoje > datadeVencimento : false;

          return (
            <div key={post.id} className="Cliente_coluna">
              <div
                className={`Cliente_click ${expandedClientId === post.id ? "expanded" : ""
                  }`}
                onClick={() => handleClienteClick(post)}
                style={{
                  backgroundColor: isVencida
                    ? "red"
                    : datadeVencimento
                      ? "green"
                      : "#fff",
                }}
              >
                <div className="Cliente_info">
                  <h3 className="Cliente_nome">{post.nome}</h3>
                  <div className="Cliente_email">{post.email}</div>

                  <div className="Cliente_maquina">
                    Total de máquinas: {post.Maquina?.length}
                  </div>
                  <div className="Cliente_footer">
                    <div>
                      Data de Inclusão:{" "}
                      {format(new Date(post.dataInclusao), "dd/MM/yyyy - kk:mm")}
                    </div>
                    <div>
                      Último Acesso:{" "}
                      {post.ultimoAcesso
                        ? format(
                          new Date(post.ultimoAcesso),
                          "dd/MM/yyyy - kk:mm"
                        )
                        : "--"}
                    </div>
                    <div>
                      {datadeVencimento && (
                        <span>
                          {isVencida
                            ? `VENCIDO: ${format(
                              datadeVencimento,
                              "dd/MM/yyyy"
                            )}`
                            : `VENCIMENTO: ${format(
                              datadeVencimento,
                              "dd/MM/yyyy"
                            )}`}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );


};

export default ClientesDashboard;